import logo from '../img/logo.png'

function Home() {

  return (<div>    
    <div className="image-div"><img src={logo} alt="Küstenspacken Logo" class="title-image" /></div>
  </div>)
}

export default Home